import { useNavigate } from "react-router-dom";
import {
  FaEnvelope,
  FaUserTie,
  FaClipboardList,
  FaHistory,
  FaArrowRight,
  FaCalendarCheck,
} from "react-icons/fa";
import { useEffect, useState } from "react";
import FullPageSpinner from "../../components/FullPageSpinner";
import { sendRequest } from "../../utils/api";
import { IconType } from "react-icons";


interface LogMenu {
  id: number;
  title: string;
  description: string;
  icon: IconType;
  total: number;
  route: string;
  active: boolean;
}

//   {
//     id: 3,
//     title: "Audit Logs",
//     description: "Administrative and system audit records.",
//     icon: FaClipboardList,
//     total: 0,
//     route: "",
//     active: false,
//   },
//   {
//     id: 4,
//     title: "Activity Logs",
//     description: "Track user and staff activities.",
//     icon: FaHistory,
//     total: 0,
//     route: "",
//     active: false,
//   },



export default function LogMenu() {
  const navigate = useNavigate();

  const [logMenus, setLogMenus] = useState([] as LogMenu[])
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const logsCount = async () => {
      setLoading(true);
      try {
        const logCount = await sendRequest("GET", "/logs/count");
        const { contactCount, jopApplicantCount, attendanceCount } = logCount;

        const logMenus = [
          {
            id: 1,
            title: "Contact Logs",
            description: "Messages submitted through the contact form.",
            icon: FaEnvelope,
            total: contactCount ?? 0,
            route: "/contacts",
            active: true,
          },
          {
            id: 2,
            title: "Attendance Logs",
            description: "Record of staff clock-in & lock-out activities.",
            icon: FaCalendarCheck,
            total: attendanceCount ?? 0,
            route: "/attendance-logs",
            active: true,
          },
          {
            id: 3,
            title: "Applicant Logs",
            description: "Applications received from the careers page.",
            icon: FaUserTie,
            total: jopApplicantCount ?? 0,
            route: "/applicants",
            active: false,
          },
        ];

        setLogMenus(logMenus);

      } catch (err: any) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    }
    logsCount();
  }, [])


  return (
    <div className="p-6">
      <div className="mb-8">

        <FullPageSpinner show={loading} />

         <h1 className="text-2xl font-bold">Logs</h1>
        {/* <p className="mt-2 text-gray-500">
          View and manage all incoming records.
        </p> */}
      </div>

      <div className="grid gap-6 sm:grid-cols-2 xl:grid-cols-2">
        {logMenus.map((item) => {
          const Icon = item.icon;

          return (
            <div
              key={item.id}
              onClick={() => item.active && navigate(item.route)}
              className={`group rounded-xl border bg-white p-6 transition-all duration-300 ${item.active
                ? "cursor-pointer hover:-translate-y-1 hover:border-blue-500 hover:shadow-lg"
                : "cursor-not-allowed opacity-60"
                }`}
            >
              <div className="flex items-center justify-between">
                <div className="rounded-lg bg-blue-100 p-4">
                  {Icon({ className: "text-2xl text-blue-600" })}
                </div>

                {!item.active && (<span
                  className={`rounded-full px-3 py-1 text-xs font-medium ${item.active
                    ? "bg-green-100 text-green-700"
                    : "bg-gray-100 text-gray-500"
                    }`}
                >
                  {item.active ? "Available" : "Coming Soon"}
                </span>)}
              </div>

              <h2 className="mt-5 text-lg font-semibold text-gray-800">
                {item.title}
              </h2>

              <p className="mt-2 text-sm text-gray-500">
                {item.description}
              </p>

              <div className="mt-6 flex items-center justify-between border-t pt-4">
                <div>
                  <p className="text-xs text-gray-500">Total Records</p>
                  <p className="text-2xl font-bold">{item.total}</p>
                </div>

                {item.active && (
                  FaArrowRight({ className: "text-blue-600 transition-transform group-hover:translate-x-1" })
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}